import UserRole from 'umg-ember-backend/components/record-explorer/for/user-role';

<template><UserRole @records={{@model}} @recordType='user-role' /></template>
